import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const QuestionsImplants = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
                Am I suitable?
              </Accordion.Header>
              <Accordion.Body>
                Anyone who has lost a tooth or several teeth is a candidate for
                dental implants.As long as a full assessment is completed and
                treatment is planned properly and tailored to suit the
                individual’s specific requirements, then dental implants can
                usually be placed. Patients are assessed on an individual basis;
                every patient will have a thorough consultation using a
                combination of radiographic and diagnostic techniques, with an
                in depth analysis of their lifestyle and objectives.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
                I have gum disease, can I have implants?
              </Accordion.Header>
              <Accordion.Body>
                Yes, periodontal patients can have dental implants. However, it
                is important the gum disease affecting your remaining natural
                teeth is adequately treated before implant placement. It is also
                important to note that the risk of complications related to
                implant treatment seems to be somewhat higher in periodontal
                patients, but with regular maintenance, it is not a
                contraindication.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
                Will you have to remove or treat diseased teeth prior to
                treatment?
              </Accordion.Header>
              <Accordion.Body>
                Despite advances in modern dentistry some teeth may have reached
                a stage where no treatment can save them. It is often best to
                remove them at an early stage, particularly if you are thinking
                of having implants so as to prevent further bone loss. We would
                need to treat or remove all pre-existing oral infection wherever
                possible.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
                How long do implants last?
              </Accordion.Header>
              <Accordion.Body>
                Implants have high success rates and there are reports that have
                assessed their performance over a period of more than 25 years.
                The most recent studies indicate that 90% of implants placed ten
                years ago are still functional today. The long-term success of
                implants also depends greatly on how well they are cleaned and
                maintained. In most cases, as a minimum, an annual check-up and
                regular hygienist visits are recommended so the implants can be
                professionally cleaned. Moreover, brushing and flossing at home
                is of paramount importance.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="5"
              onClick={() => handleToggle("5")}
            >
              <Accordion.Header as="h3" className="red-header">
                What is a sinus graft?
              </Accordion.Header>
              <Accordion.Body>
                It is very common to find that the softer bone in the area above
                the upper back teeth is very shallow and not suitable for normal
                implant procedures. To solve this problem a procedure known as a
                “sinus augmentation” or “sinus lift” was developed. Bone may be
                successfully grown in the sinus spaces above your upper back
                teeth allowing implants to be placed.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="6"
              onClick={() => handleToggle("6")}
            >
              <Accordion.Header as="h3" className="red-header">
                I’m a really nervous patient, what are my options?
              </Accordion.Header>
              <Accordion.Body>
                Is dental fear and phobia preventing you from having your
                perfect smile with dental implants? We understand that a visit
                to the dentist can be quite challenging. We believe everybody
                deserves a smile that is healthy and happy and we are committed
                to working with you to help get treatment. That’s why we have
                adopted a relaxed and informal approach that helps put our
                patients at ease. Moreover, we offer dental sedation to ensure
                you never skip your next dental appointment again. Dr Nadeem
                Sabir provides patients treatment with Intravenous Sedation,
                which involves the controlled delivery of a sedative drug, which
                quickly induces feelings of deep relaxation and peace. Further,
                this leaves you with little or no recollection of the procedure.
                Intravenous sedation is not like a general anaesthetic, in that
                you do not lose consciousness. We have been able to help many
                patients finally overcome dental anxiety by providing them the
                dental treatment they need using a relaxed and calming approach.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
                Can dental implants be done in a single day?
              </Accordion.Header>
              <Accordion.Body>
                Yes, dental implants can sometimes be done in a single day, a
                procedure known as “same-day dental implants” or “teeth in a
                day.” This approach allows for the placement of the implant and
                a temporary crown or bridge in a single visit. However, not all
                patients are suitable candidates for this procedure.Some Factors
                That Determine Eligibility: Bone Density & Health – Adequate
                bone structure is needed to support the implant. Oral Health –
                Healthy gums and no active infections or gum disease are
                essential. Overall Health – Conditions like diabetes or smoking
                habits may affect healing.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
                What is the difference between full arch implants and
                traditional dentures?
              </Accordion.Header>
              <Accordion.Body>
                The main difference between full arch implants and traditional
                dentures is how they are supported and secured in the mouth.
                Full mouth implants are anchored to the jawbone using 4-6 dental
                implants usually. They are very secure and do no not slip or
                move like dentures. Full arch implants feel more like natural
                teeth and there is no need for adhesives unlike dentures.
                Further, implants help preserve jawbone by preventing bone loss
                whereas dentures do not do this, which can lead to changes in
                facial structure. Full arch implants are the better option for
                long-term oral health, comfort and function.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="9"
              onClick={() => handleToggle("9")}
            >
              <Accordion.Header as="h3" className="red-header">
                What is the average lifespan of dental implants?
              </Accordion.Header>
              <Accordion.Body>
                Implants have high success rates and there are reports that have
                assessed their performance over a period of more than 25 years.
                The most recent studies indicate that 90% of implants placed ten
                years ago are still functional today. The long-term success of
                implants also depends greatly on how well they are cleaned and
                maintained. In most cases, as a minimum, an annual check-up and
                regular hygienist visits are recommended so the implants can be
                professionally cleaned. Moreover, brushing and flossing at home
                is of paramount importance.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="10"
              onClick={() => handleToggle("10")}
            >
              <Accordion.Header as="h3" className="red-header">
                How should I maintain and clean my full arch implants?
              </Accordion.Header>
              <Accordion.Body>
                Cleaning full arch implants is crucial to maintaining oral
                health and preventing complications like gum disease around
                implants. Caring for implants includes brushing twice a day,
                flossing, using an antibacterial mouthwash, and regular dental
                check-ups. We also recommend specific tools, like a water
                flosser, to clean around the implants. An annual check-up and
                regular hygienist visits are recommended so the implants can be
                professionally cleaned.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="11"
              onClick={() => handleToggle("11")}
            >
              <Accordion.Header as="h3" className="red-header">
                Will I experience pain during or after the implant procedure?
              </Accordion.Header>
              <Accordion.Body>
                During the dental implant procedure, you shouldn’t feel any pain
                because wea will use a local anaesthetic to numb the area. You
                may feel some pressure or mild discomfort, but it shouldn’t be
                painful. We also provide intravenous sedation for patients who
                are anxious. After the procedure, it’s normal to experience some
                soreness, swelling, and mild discomfort for a few days. This is
                usually manageable with over-the-counter pain relievers like
                ibuprofen or paracetamol. Most people find the discomfort
                improves significantly within a 24-48 hours.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="12"
              onClick={() => handleToggle("12")}
            >
              <Accordion.Header as="h3" className="red-header">
                How soon can I eat normally after getting implants?
              </Accordion.Header>
              <Accordion.Body>
                You can typically eat a few hours after your dental implant
                procedure. However, you should stick to soft foods and
                liquidsfor at least the first 24 to 48 hours to avoid disturbing
                the surgical site and avoid anything to hot.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="13"
              onClick={() => handleToggle("13")}
            >
              <Accordion.Header as="h3" className="red-header">
                Will my speech be affected by full arch implants?
              </Accordion.Header>
              <Accordion.Body>
                Full arch implants can affect your speech, especially in the
                initial adjustment period. However, most people adapt quickly,
                and speech typically improves over time. Most patients find that
                their speech returns to normal or even improves as they get used
                to their implants.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionsImplants;
